import { prop } from 'ramda'

// TODO - move to helpers
export const handleStockErrors = (replies, errors) => {
  const hasStockError = errors.find(err => ['insufficient_amount', 'value_lte_zero'].some(m => err.message.includes(m)))
  if (hasStockError) {
    const indexOf = hasStockError.message.lastIndexOf('_')
    const error = hasStockError.message.substring(0, indexOf)
    const clientCode = hasStockError.message.slice(indexOf + 1)
    replies.forEach(reply => {
      reply.error = null
      if (reply.type === 'block') {
        reply.value.forEach(blockValue => {
          blockValue.forEach(blockReply => {
            blockReply.error = null
            if (blockReply?.value?.clientCode === clientCode) {
              reply.error = 'error'
              blockReply.error = error
              blockReply.value.error = error
            }
          })
        })
      } else {
        reply.error = null
        if (reply?.value?.clientCode === clientCode) {
          reply.error = error
        }
      }
    })
  }
}

// TODO - move to helpers
export const indexOfFirstInvalidReply = replies => {
  return replies
    .filter(prop('shouldRender')) //
    .reduce((indexesMap, reply, index) => {
      if (!!indexesMap) return indexesMap
      if (!reply.validations.isValid) {
        return { itemIndex: index, questionId: reply.questionId }
      }
      return null
    }, null)
}

// TODO - move to helpers
export const indexOfFirstInvalidStockReply = replies =>
  replies.reduce((acc, reply, index) => {
    if (!!acc) return acc
    if (reply.error) {
      return { itemIndex: index, questionId: reply.questionId }
    }
    return null
  }, null)
